import axios from "axios";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { addToast } from "./ui";

export const reloadAccount = accountID => {
    const queryClient = useQueryClient();
    queryClient.invalidateQueries([accountID, "account"]);
};

export const useAccountID = () => useParams().accountID;

export const accountQuery = accountID => ({
    queryKey: [accountID, "account"],
    queryFn: () => axios.get(`/api/${accountID}`).then(res => res.data)
});

export const useAccount = () => {
    const accountID = useAccountID();
    return useQuery(accountQuery(accountID));
};

export function changeAccountInfo(accountID, account) {
    return async (dispatch, getState) => {
        await axios.put(`/api/${accountID}`, account);
        reloadAccount(accountID);
        dispatch(addToast("Account saved"));
    };
}

export function feedScan(accountID) {
    return async (dispatch, getState) => {
        await axios.post(`/api/${accountID}/feedscan`);
        dispatch(addToast("Feed scan scheduled"));
    };
}

export const usePublishMonths = accountID => useQuery({
    queryKey: [accountID, "publish-months"],
    queryFn: () => axios.get(`/api/${ accountID }/publish-months`).then(res => res.data)
});